import { Components, Theme } from '@mui/material';

export const MuiSkeleton: Components<Theme>['MuiSkeleton'] = {
  defaultProps: {
    role: 'progressbar',
  },
};
